import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, type InquiryRow } from '../../lib/api.js';

export function CustomerInquiries() {
  const [inquiries, setInquiries] = useState<InquiryRow[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .get<{ inquiries: InquiryRow[] }>('/api/customer/inquiries')
      .then((res) => setInquiries(res.inquiries))
      .catch((err) => setError((err as Error).message));
  }, []);

  return (
    <div>
      <header className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-semibold tracking-tight">문의</h1>
        <Link
          to="/customer/inquiries/new"
          className="px-3 py-1.5 bg-brand-400 hover:bg-brand-600 text-white text-sm font-medium rounded-md"
        >
          + 새 문의
        </Link>
      </header>

      {error && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md text-sm text-red-700">
          {error}
        </div>
      )}

      <div className="bg-surface border border-neutral-200 rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-neutral-50 text-neutral-600 text-xs uppercase tracking-wide">
            <tr>
              <th className="text-left px-4 py-2 font-medium">제목</th>
              <th className="text-left px-4 py-2 font-medium">카테고리</th>
              <th className="text-left px-4 py-2 font-medium">상태</th>
              <th className="text-left px-4 py-2 font-medium">최근 메시지</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-neutral-100">
            {inquiries.map((i) => (
              <tr key={i.id} className="hover:bg-neutral-50/50">
                <td className="px-4 py-2">
                  <Link
                    to={`/customer/inquiries/${i.id}`}
                    className="text-brand-600 hover:underline font-medium"
                  >
                    {i.subject}
                  </Link>
                </td>
                <td className="px-4 py-2 text-neutral-600">
                  {i.category === 'product' ? '제품 문의' : '라이선스 문의'}
                </td>
                <td className="px-4 py-2">
                  {i.status === 'open' ? (
                    <span className="text-green-700 text-xs font-medium">open</span>
                  ) : (
                    <span className="text-neutral-500 text-xs font-medium">closed</span>
                  )}
                </td>
                <td className="px-4 py-2 text-neutral-500 text-xs">
                  {new Date(i.lastMessageAt).toLocaleString('ko-KR')}
                </td>
              </tr>
            ))}
            {inquiries.length === 0 && (
              <tr>
                <td colSpan={4} className="px-4 py-8 text-center text-neutral-500">
                  아직 문의가 없습니다.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
